module.exports = __webpack_public_path__ + "static/media/protones-placeholder-1.3626915b.png";